module.exports = __webpack_public_path__ + "static/media/ii-ambientworks.2502cde.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ambient-works/ii-ambientworks.mp3
// module id = rdUk
// module chunks = 0